(function ($) {
    var currentInformationPage = 1;
    var informationAjax = null;
    var ajaxTimeout = null;
    var filters = [];
    var template = $('#js-information-item').html();
    var templatelist = $('#js-information-item-list').html();
    var infoCount = $('#info-count');

    var loadInformation = function () {
        var $loader = $('.js-information-loader');
        var $list = $('.js-information-list');
        var $list2 = $('.js-information-list2');
        var $loadMore = $('.js-information-next-page');

        Mustache.parse(template);

        Mustache.parse(templatelist);

        var data = {
            page: currentInformationPage,
            nonce: rissb_var.nonces.get_information,
        };

        if (window.matchMedia('(max-width: 768px)').matches) {
            data.filters = $('.filter-mobile .js-information-filters :input').serialize();
        } else {
            data.filters = $('.js-information-year-filter:checkbox:checked, .js-information-topic-filter:checkbox:checked, .js-information-category-filter:checkbox:checked').serialize();
        }

        data.searchString = $('#search-info').val();

        data.sort = $('input[name="sort[]"]').serialize();

        if (data.page == 1) {
            $loader.removeClass('d-none');
            $list.empty();
            $list2.empty();
        }

        if (informationAjax) {
            informationAjax.abort();
        }

        informationAjax = $.post('/api/information', data, function (res) {
            var rendered = Mustache.render(template, res.data);

            var rendered2 = Mustache.render(templatelist, res.data);

            $loader.addClass('d-none');

            // List rendering
            $list.html(rendered);

            $list2.html(rendered2);

            $(rendered).imagesLoaded(function () {
                $.fn.matchHeight._apply('[data-mh="card-information"]');
            });

            $(rendered2).imagesLoaded(function () {
                $.fn.matchHeight._apply('[data-mh="card-information"]');
            });

            // Pagination
            generatePagination(res.data.pagination);

            // Update count
            infoCount.text(res.data.data.length);

        }).always(function () {
            $loadMore.text($loadMore.data('text-original'));
        });
    };

    var generatePagination = function (pagination) {

        var pages = '';
        for (var index = 1; index <= pagination.total; index++) {
            if (pagination.current === index) {
                pages += '<li class="page-item list-inline-item"><a class="page-link active" href="#' + index + '">' + index + '</a></li>';
            }
            else {
                pages += '<li class="page-item list-inline-item"><a class="page-link" href="#' + index + '">' + index + '</a></li>';
            }
        }

        var listElement = '<ul class="pagination list-inline list-unstyled text-center">' +
                        '<li class="page-item list-inline-item"><a class="page-link" href="#prev"><i class="fas text-secondary fa-arrow-left"></i></a></li>' +
                        pages +
                        '<li class="page-item list-inline-item"><a class="page-link" href="#next"><i class="fas text-secondary fa-arrow-right"></i></a></li>' +
                    '</ul>';

        $('#information-pagination').html(listElement);
    };

    $(document).ready(function () {

        $( "#show-list" ).click(function() {
          $('.js-information-list').hide();
          $('.js-information-list2').show();
        });

        $( "#show-grid" ).click(function() {
          $('.js-information-list').show();
          $('.js-information-list2').hide();
        });

        if ($('body').hasClass('post-type-archive-information')) {
            RISSB.fn.clearDropdownFilter(function () {
                currentInformationPage = 1;
                loadInformation();
            });

            if ($('.js-information-list').length) {
                currentInformationPage = 1;
                loadInformation();
            }

            $('.js-information-year-filter, .js-information-topic-filter, .js-information-category-filter').on('change', function (evt) {
                loadInformation();
            });

            $('input[name="sort[]"]').on('change', function (evt) {
                loadInformation();
            });

            $(document).on('click',  '.page-link', function (evt) {
                var selectedPage = $(this).attr('href').replace('#', '');

                if (selectedPage === 'prev') {
                    currentInformationPage--;
                }
                else if (selectedPage === 'next') {
                    currentInformationPage++;
                }
                else {
                    currentInformationPage = selectedPage;
                }

                loadInformation();
            });

            $('.js-search-submit').on('click', function (evt) {
                evt.preventDefault();

                loadInformation();
            })

            $('.js-information-filters').find('.js-information-search').on('keyup input', function () {
                currentInformationPage = 1;

                clearTimeout(ajaxTimeout);
                ajaxTimeout = setTimeout(loadInformation, 500);
            });

            $('.js-update-filter').on('click', function () {
                var $this = $(this);
                currentInformationPage = 1;

                RISSB.fn.updateQSParams('news_categories[]', $this.closest('.js-information-filters').find('input[name="news_categories[]"]:checked').map(function () {
                    return $(this).val();
                }).get(), true);

                loadInformation();
                $this.closest('.dropdown-menu').removeClass('show');
            });

            $('.js-information-next-page').on('click', function (e) {
                e.preventDefault();

                var $this = $(this);
                currentInformationPage = currentInformationPage + 1;

                $this.html('<i class="fas fa-spinner fa-spin fa-fw"></i> ' + $this.data('text-progress'));
                loadInformation();
            });

            $('.js-information-list').on('click', '.js-filter-category', function (e) {
                e.preventDefault();

                var $this = $(this);

                $('.js-dropdown-filter-category').find('[type="checkbox"][name="news_categories[]"]').prop('checked', false);
                $('.js-dropdown-filter-category').find('[type="checkbox"][name="news_categories[]"][value="' + $this.data('id') + '"]').prop('checked', true).change();
                RISSB.fn.updateQSParams('news_categories[]', $this.data('id'));

                currentInformationPage = 1;

                loadInformation();
            });

            $('.js-dropdown-sort').on('click', '.dropdown-item', function (e) {
                e.preventDefault();

                var $this = $(this);
                currentInformationPage = 1;

                $('[name="orderby"]').val($this.data('orderby'));
                $('[name="order"]').val($this.data('order'));
                $('.js-order-type').text($this.text());

                loadInformation();
            });

            $('.js-information-list').on('click', '.card-news-style-1, .card-news-style-2', function (e) {
                if ($(e.target).hasClass('js-filter-category')) {
                    return;
                }

                window.location = $(this).find('.card-news-read-more').attr('href');
            });
        }

        if ($('body').hasClass('single-news')) {
            $('.is-sticky').stick_in_parent({
                offset_top: $('#wpadminbar').length ? $('#wpadminbar').outerHeight() : 0,
            });

            $content = $('.post-content');

            if ($content.find('iframe').length) {
                var contentSelector = 'div.header, .layout, .one-col .column';

                $content.find('iframe').each(function () {
                    var $iframe = $(this);

                    $iframe.removeAttr('width');
                    $iframe.css('width', '100%');
                });
            }
        }
    });
})(jQuery);
